import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// تعطيل كل رسائل التتبع (log/info/debug/warn) في المتصفح — لا تُطبع أي بيانات مستخدم أو جلسة بعد الآن
// console.error يبقى فعّالاً فقط للأخطاء الحقيقية غير المتوقعة (لا يطبع بيانات شخصية حسب الفحص)
console.log = () => {};
console.info = () => {};
console.debug = () => {};
console.warn = () => {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
